import { css } from 'emotion';
const styles = css`
  .CodeMirror{
    height: 160px;
    background: #fbfbfb;
    margin: 10px 0;
    border: 1px solid #ddd;
  }
`;

export default styles;
